enum ActType {
  DEFAULT = "DEFAULT",
  REFERRAL = "REFERRAL",
}

export default ActType;
